import { TimeRange, TimeIterator } from '@playq/octopus-common';

export const setNewTimeRangeFromIterator = (iterator: TimeIterator): TimeRange => {
  const newTimeRange = new TimeRange();
  newTimeRange.from_ = iterator.from_;
  newTimeRange.till = iterator.till;
  return newTimeRange;
};
